import React, { useState } from 'react';
import { Button, Modal } from '@mantine/core';
import { Plus } from 'tabler-icons-react';
import { InquiryForm, InquiryFormMode } from '../InquiryForm';
import { useTranslation } from 'react-i18next';

export function InquiryCreateDialog() {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  return (
    <>
      <Button
        color="green"
        size="md"
        variant="light"
        leftIcon={<Plus />}
        onClick={() => setOpened(true)}
      >
        {t('InquiryCreateDialog.Title')}
      </Button>
      <Modal
        opened={opened}
        onClose={() => setOpened(false)}
        size="lg"
        title={t('InquiryCreateDialog.Title')}
      >
        <InquiryForm
          mode={InquiryFormMode.CREATE}
          onFinish={() => setOpened(false)}
        />
      </Modal>
    </>
  );
}
